import { ConectoresFolgas, ConectoresFolgaCadastro, ConectoresFolgaDetalhes } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/folgas',
    parent: '/conectores',
    text: 'Folgas dos conectores',
    match: /\/conectores\/folgas+$/,
    sider: true,
    component: ConectoresFolgas,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/folga/:id',
    text: 'Folga',
    component: ConectoresFolgaCadastro,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/folga/detalhes/:idConfiguracao/:id',
    text: 'Folga',
    component: ConectoresFolgaDetalhes,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
